import { gql } from '@apollo/client'

export const GET_ORGANIZER_ROLES = gql`
  query GetOrganizerRoles {
    currentUser {
      id
      roles
      organizer {
        organizerId
        listRoles
      }
    }
  }
`
